import { css, styled } from 'styled-components';

import { styledTypography } from '@pkg/primitives';

export const Container = styled.div`
    background: #fff;
    border-radius: 20px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #000;
    height: 240px;
    @media (min-width: 768px) {
        height: 300px;
    }
`;

export const UrlText = styled.p`
    ${styledTypography.allianceBase};
    display: flex;
    color: #000;
    font-weight: 700;
`;

export const BodyText = styled.p`
    ${styledTypography.allianceBase};
    display: flex;
    letter-spacing: -0.9px;
    color: ${({ theme }) => theme.shades.black[30]};
    font-size: 14px;
    @media (min-width: 768px) {
        font-size: 16px;
    }
`;
export const InfoPill = styled.div`
    background: #fff;
    border-radius: 60px;
    bottom: 50px;
    color: #000;
    font-weight: 600;
    font-size: 12px;
    line-height: 96%;
    padding: 14px 16px;
    position: absolute;
    right: 25px;
`;
export const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    height: 40px;
    padding: 10px 0 20px;
`;
export const ContentContainer = styled.div<{ $isEmptyImg?: boolean }>`
    position: relative;
    padding: 10px 10px 0;
    width: 100%;
    display: flex;
    height: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    svg {
        fill: none;
        circle {
            stroke: ${({ theme }) => theme.colors.purple};
        }
    }

    @media (min-width: 768px) {
        padding: 15px 15px 0;
    }
`;

export const ImageBg = styled.div<{ $image: string; $isEmptyImg?: boolean }>`
    width: 100%;
    height: 260px;
    border-radius: 20px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    overflow: hidden;
    background-color: ${({ theme }) => theme.shades.white[7]};
    ${({ $image }) =>
        $image &&
        css`
            background-image: url(${$image});
        `}

    ${({ $isEmptyImg }) =>
        $isEmptyImg &&
        css`
            background-size: contain;
            background-position: top;
            height: 120px;
            @media (min-width: 768px) {
                height: 200px;
            }
        `}
`;
